import { render, staticRenderFns } from "./ComboBox.vue?vue&type=template&id=5aec8fd8&scoped=true&"
import script from "./ComboBox.vue?vue&type=script&lang=js&"
export * from "./ComboBox.vue?vue&type=script&lang=js&"
import style0 from "./ComboBox.vue?vue&type=style&index=0&id=5aec8fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec8fd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCombobox,VIcon})
